import * as React from 'react'
import { useState } from 'react'

import { isFER } from '~/utils/isReservableType'

import FERMenuTab from '~/components/Restaurant/FerMenuTab/FerMenuTab'
import { MenuTabContainer, MenuTabPill, PillsContainer } from '~/components/Restaurant/MenuTab/MenuTabShards'
import { ReservableExtraMenuTab } from '~/components/Restaurant/ReservableExtraMenuTab/ReservableExtraMenuTab'
import { Reservable, ReservablesQuery, SingleRestaurantQuery } from '~/generated/graphql'
import { gt } from '~/locale'

type MenuTabViewProps = {
  reservables: ReservablesQuery['reservables']
  restaurant: Pick<NonNullable<SingleRestaurantQuery['restaurant']>, 'reservableExtras' | 'id' | 'reservables'>
  onReserveClick: () => void
}

const CHEFS_MENU_PILL_ID = 'chm'

export const MenuTabView = ({ reservables, restaurant, onReserveClick }: MenuTabViewProps) => {
  const ferReservables = reservables.filter(isFER)

  const hasFer = ferReservables.length > 0
  const chmCount = restaurant.reservableExtras.length
  const hasCHM = chmCount > 0

  const initialActivePill = hasFer ? ferReservables[0].id : CHEFS_MENU_PILL_ID

  const [selectedPillId, setSelectedPillId] = useState<Reservable['id'] | typeof CHEFS_MENU_PILL_ID>(initialActivePill)

  const activeFerReservable = ferReservables.find(reservable => reservable.id === selectedPillId)

  return (
    <MenuTabContainer>
      <PillsContainer>
        {ferReservables.map(reservable => {
          return (
            <MenuTabPill key={reservable.id} isSelected={selectedPillId === reservable.id} onClick={() => setSelectedPillId(reservable.id)}>
              {reservable.festivalEdition.festival.name}
            </MenuTabPill>
          )
        })}
        {hasCHM && (
          <MenuTabPill key={'chm'} isSelected={selectedPillId === CHEFS_MENU_PILL_ID} onClick={() => setSelectedPillId(CHEFS_MENU_PILL_ID)}>
            {gt.tp('ProductPage', '#ChefsMenu')} ({chmCount})
          </MenuTabPill>
        )}
      </PillsContainer>
      {activeFerReservable && <FERMenuTab fer={activeFerReservable} onReserveClick={onReserveClick} />}
      {selectedPillId === CHEFS_MENU_PILL_ID && (
        <ReservableExtraMenuTab restaurant={restaurant} crossSells={[]} onReserveClick={onReserveClick} />
      )}
    </MenuTabContainer>
  )
}
